import { api, ApiError } from "../lib/api";
import { setToken, setUser, type User } from "../lib/auth";
import { navigate } from "../lib/router";

interface LoginResponse {
  token: string;
  user: User;
}

export function renderLoginPage(root: HTMLElement): void {
  const shell = document.createElement("div");
  shell.className = "login-shell";

  const card = document.createElement("form");
  card.className = "login-card";
  card.innerHTML = `
    <h1><img src="/logo.png" class="login-logo" alt="" /><span>Kassandra</span></h1>
    <p class="subtitle muted">Sign in to continue</p>
    <div class="login-field">
      <label for="login-username">Username</label>
      <input id="login-username" name="username" type="text" autocomplete="username" required />
    </div>
    <div class="login-field">
      <label for="login-password">Password</label>
      <input id="login-password" name="password" type="password" autocomplete="current-password" required />
    </div>
    <div class="login-error" role="alert"></div>
    <button type="submit" class="primary">Login</button>
  `;

  const errEl = card.querySelector<HTMLDivElement>(".login-error")!;
  const submitBtn = card.querySelector<HTMLButtonElement>("button[type=submit]")!;
  const usernameInput = card.querySelector<HTMLInputElement>("#login-username")!;
  const passwordInput = card.querySelector<HTMLInputElement>("#login-password")!;

  card.addEventListener("submit", async (e) => {
    e.preventDefault();
    errEl.textContent = "";
    submitBtn.disabled = true;
    submitBtn.textContent = "Signing in...";

    try {
      const res = await api<LoginResponse>("/auth/login", {
        method: "POST",
        body: { username: usernameInput.value, password: passwordInput.value },
        auth: false,
      });
      setToken(res.token);
      setUser(res.user);
      navigate("/dashboard");
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        errEl.textContent = "Invalid username or password";
      } else {
        errEl.textContent = err instanceof Error ? err.message : "Login failed";
      }
      submitBtn.disabled = false;
      submitBtn.textContent = "Login";
    }
  });

  const disclaimer = document.createElement("p");
  disclaimer.className = "login-disclaimer";
  disclaimer.textContent =
    "This website is created for learning purposes only. The information provided here should not be " +
    "considered professional advice. Please note that we make no guarantees regarding the accuracy, " +
    "completeness, or reliability of the contents of this website. Any actions you take based on the " +
    "content of this website are at your own risk. We are not liable for any losses or damages " +
    "incurred from the use of this website.";

  shell.appendChild(card);
  shell.appendChild(disclaimer);
  root.appendChild(shell);
  usernameInput.focus();
}
